import InternalStaticAnchorRules from 'models/application/anchor/types/internalStatic/types/Rules';

export default class InternalStaticAnchorRulesService {
	toModel(anchor) {
		return new InternalStaticAnchorRules(anchor);
	}
}
